export default "/images/vendor/flag-icons/flags/4x3/ge.svg?3c65f52fda94c4461ae5012db03442bb";